import axios from 'axios';
import { call, put, takeEvery } from 'redux-saga/effects';
import fileDownload from 'js-file-download';
import { api } from 'services/api';
import { notificationContainer } from 'utils/notificationContainer';
import { PayloadAction } from '@reduxjs/toolkit';
import {
	TDownloadEmVatReportRequest,
	TDownloadEmVatReportResponse,
	TEmVatReportsListRequest,
	TEmVatReportsListResponse,
} from './types';
import {
	downloadEmVatReportFinally,
	downloadEmVatReportRequest,
	emVatReportsInitState,
	getEmVatReportsListRequest,
	getEmVatReportsListSuccess,
} from './reducer';

function* getEmVatReportsListRequestWorker(action: PayloadAction<TEmVatReportsListRequest>) {
	const { payload } = action;
	try {
		const response: TEmVatReportsListResponse = yield call(
			api.emVatReports.getEmVatReportsList,
			payload,
		);
		yield put(getEmVatReportsListSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error), 'error');
		}
		yield put(emVatReportsInitState());
	}
}

function* downloadEmVatReportWorker(action: PayloadAction<TDownloadEmVatReportRequest>) {
	const { url, fileName } = action.payload;
	try {
		const response: TDownloadEmVatReportResponse = yield call(
			api.emVatReports.downloadEmVatReport,
			url,
		);
		if (response) {
			fileDownload(response, fileName);
		}
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error), 'error');
		}
	} finally {
		yield put(downloadEmVatReportFinally());
	}
}

export function* emVatReportsSaga() {
	yield takeEvery(getEmVatReportsListRequest.type, getEmVatReportsListRequestWorker);
	yield takeEvery(downloadEmVatReportRequest.type, downloadEmVatReportWorker);
}
